<template>
    <button type="button" v-if="showRidingWithAdults" class="icon-filter" :aria-pressed="isPressed"  v-bind:class="{ active: isActive }" data-filter="RidingWithAdult" @click="addFilter">
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
                <path d="M27.351 25.744a4.31 4.31 0 013.864.573A4.236 4.236 0 0133 29.765v.721a.643.643 0 01-.646.641h-.906l-.637 3.788a.644.644 0 01-.637.535h-2.906a.644.644 0 01-.637-.535l-.364-2.168a.646.646 0 011.274-.21l.274 1.632h1.812l.637-3.788a.644.644 0 01.637-.535h.807v-.08c0-.955-.464-1.851-1.246-2.407a3.011 3.011 0 00-2.698-.4.64.64 0 11-.413-1.215zM25.006 24.534c-.099-2.655-2.3-4.778-5.001-4.778-2.764 0-5.004 2.223-5.004 4.964v2.882l.006.087a.644.644 0 00.64.554h.869l.668 6.629.015.087c.069.284.326.49.628.49h4.359l.089-.006a.644.644 0 00.554-.571l.668-6.629h.869l.088-.006a.642.642 0 00.558-.635V24.72l-.006-.186zm-1.288 2.429h-.808l-.089.006a.644.644 0 00-.554.571l-.668 6.629h-3.19l-.668-6.629-.015-.087a.646.646 0 00-.628-.49h-.807v-2.242l.004-.173c.091-1.954 1.717-3.51 3.709-3.51 2.051 0 3.713 1.649 3.713 3.683v2.242zM28.722 19.756c-1.56 0-2.825 1.255-2.825 2.802 0 1.548 1.265 2.802 2.825 2.802 1.56 0 2.825-1.255 2.825-2.802 0-1.547-1.265-2.802-2.825-2.802zm0 4.324a1.528 1.528 0 01-1.534-1.521c0-.84.687-1.521 1.534-1.521s1.534.681 1.534 1.521c0 .84-.687 1.521-1.534 1.521zM20.004 12.55c-1.961 0-3.552 1.577-3.552 3.523s1.59 3.523 3.552 3.523 3.552-1.577 3.552-3.523-1.59-3.523-3.552-3.523zm0 5.765a2.251 2.251 0 01-2.26-2.242c0-1.238 1.012-2.242 2.26-2.242s2.26 1.004 2.26 2.242a2.25 2.25 0 01-2.26 2.242z" />
                <circle fill="none" stroke="currentColor" stroke-miterlimit="10" cx="24" cy="24" r="23.5" class="hands-off" />
            </svg>
        </span>
        <div class="icon-text">
            {{iconFilters.Text}}
        </div>
    </button>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';

export default {
    data: function () {
        return {
            isActive: false,
            iconFilters: ''
        }
    },
    methods: {
        addFilter(e) {
            this.$store.commit('filters/toggleActiveFilters', this.$el.dataset.filter);
            this.toggleActive();
            this.$store.dispatch('filterAttractions');
        },
        toggleActive() {
            if (this.$store.state.filters.activeFilters.includes(this.$el.dataset.filter)) {
                this.isActive = true;
            } else {
                this.isActive = false;
            }
        }
    },
    mounted() {
        this.iconFilters = this.getSliderIconFilters;
    },
    computed: {
        ...mapGetters('filters', ['getSliderIconFilters']),
        ...mapState('filters', ['showRidingWithAdults']),
        isPressed() {
            return this.isActive.toString();
        }
    }
}
</script>